import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { SessionService } from "../Services/session.service";

@Injectable()
export class NeedsSession  {
    constructor(private router: Router, private sessionService: SessionService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {        
        return this.sessionService.currentSession.pipe(map( session => {
            if (session === null) {
                return this.router.createUrlTree(environment.startRoute)
            } else {
                return true
            }
        }))
    }
}